import { Route, Routes as RouterRoutes } from "react-router-dom";
import About from "./views/About/About";
import Calendar from "./views/Calendar/Calendar";
import Contact from "./views/Contact/Contact";
import FestDetail from "./views/FestDetail/FestDetail";
import Fests from "./views/Fests/Fests";
import MapView from "./views/Map/MapView";

export const routeList = [
  {
    path: "/",
    element: <MapView />,
    title: "RenCamp | Plan the faire. Sleep nearby.",
  },
  {
    path: "/fests",
    element: <Fests />,
    title: "Fests | RenCamp",
  },
  {
    path: "/fests/:id",
    element: <FestDetail />,
    title: "Fest | RenCamp",
  },
  {
    path: "/calendar",
    element: <Calendar />,
    title: "Calendar | RenCamp",
  },
  {
    path: "/about",
    element: <About />,
    title: "About | RenCamp",
  },
  {
    path: "/contact",
    element: <Contact />,
    title: "Contact | RenCamp",
  },
];

export const AppRoutes = () => (
  <RouterRoutes>
    {routeList.map((route) => (
      <Route key={route.path} path={route.path} element={route.element} />
    ))}
  </RouterRoutes>
);
